import { Link } from "react-router-dom";
import { useAuth } from "../../../context/authProvider";
import AdminPage from "../../core/admin/adminPage";
import { getAdminNav } from "../../core/admin/adminNav";
import { ArrowRightIcon } from "../../../img/svg/adminIcons";

export default function AdminHome() {

    const { user } = useAuth();

    // mesmos itens do menu (exceto o próprio Início), agrupados por seção
    const sections = getAdminNav(user?.roles)
        .map(section => ({ ...section, items: section.items.filter(item => item.segment !== "") }))
        .filter(section => section.items.length);

    const firstName = user?.name?.split(" ")[0];

    return (
        <AdminPage
            title={firstName ? `Olá, ${firstName}` : "Início"}
            description="Boas vindas ao site administrativo do Classificados GMT-3! Escolha abaixo por onde começar."
        >
            {
                sections.map((section, sIdx) => (
                    <section key={sIdx}>
                        {
                            section.title ?
                                <h2 className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-gray-500">{section.title}</h2>
                                : null
                        }
                        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3">
                            {
                                section.items.map(item => (
                                    <Link key={item.to} to={item.to} className="group flex items-start gap-4 rounded-xl border border-gray-200 bg-white p-4 shadow-sm transition hover:border-gray-300 hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary">
                                        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-gray-900 text-white transition-colors group-hover:bg-secondary">{item.icon}</span>
                                        <span className="min-w-0 flex-1">
                                            <span className="flex items-center justify-between gap-2 font-bold text-gray-900">
                                                {item.label}
                                                <span className="text-gray-300 transition group-hover:translate-x-0.5 group-hover:text-gray-900"><ArrowRightIcon width="16px" /></span>
                                            </span>
                                            <span className="mt-0.5 block text-sm text-gray-500">{item.description}</span>
                                        </span>
                                    </Link>
                                ))
                            }
                        </div>
                    </section>
                ))
            }
        </AdminPage>
    )
}
